import React from 'react'
import { Message } from '@paypalcorp/worldready-react'
import axios from '../../../utils/axios-util'
import {
  INVALID_PASSWORD_REGEX,
  VALID_EMAIL_REGEX,
  VALID_NAME,
  VALID_URL_PATTERN,
  VALID_WEBHOOK_URL_PORT_REGEX,
  VALID_WEBHOOK_URL_REGEX,
} from '../../../../../server/src/shared/regex'

export function validatePassword(value) {
  let passwordLength = value && value.length
  if (!passwordLength) {
    return <Message id="validate.password.required" />
  } else if (passwordLength < 8) {
    return <Message id="validate.password.atleast" />
  } else if (passwordLength > 20) {
    return <Message id="validate.password.atmost" />
  } else if (value.indexOf(' ') !== -1) {
    return <Message id="validate.password.notspaces" />
  } else if (INVALID_PASSWORD_REGEX.test(value)) {
    return <Message id="validate.password.password" />
  }

  return undefined
}

export async function validateAccountEmail(email, csrf) {
  if (!VALID_EMAIL_REGEX.test(email)) {
    return { err: 'validate.email.valid' }
  }
  const urlValidateEmail = '/dashboard/api/accounts/create/available'
  let formEmail = { email }
  try {
    let response = await axios({
      method: 'post',
      url: urlValidateEmail,
      data: formEmail,
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-csrf-token': csrf,
      },
      responseType: 'json',
      contentType: 'application/json',
    })
    if (response && response.data?.isExisted) {
      return { err: 'validate.email.alreadyexist' }
    }

    return { res: 'validate.email.available' }
  } catch (error) {
    return { err: 'validate.email.error', statusCode: error?.request?.status }
  }
}

export function validateAccountPassword(password) {
  if (password) {
    let passwordLength = password.length
    if (passwordLength < 8) {
      return { err: 'validate.password.atleast' }
    } else if (password.indexOf(' ') !== -1) {
      return { err: 'validate.password.notspaces' }
    } else if (INVALID_PASSWORD_REGEX.test(password)) {
      return { err: 'validate.password.password' }
    }

    return {}
  }

  return { err: 'validate.password.required' }
}

export function validateBalance(value) {
  const floatValue = parseFloat(value)
  if (floatValue > 100000) {
    return <Message id="validate.balance.length" />
  }
  return null
}

export function validateWebhookURL(value) {
  if (!value) {
    return <Message id="validate.webhookURL.required" />
  } else if (value.indexOf('https') === -1) {
    return <Message id="validate.webhookURL.validHttps" />
  } else if (VALID_WEBHOOK_URL_PORT_REGEX.test(value)) {
    // RegEx to check if port number is specified in the URL or not.
    // It will return true if there is a number after : in the URL
    if (value.indexOf(':443') === -1) {
      return <Message id="validate.webhookURL.validPort" />
    }
  } else if (!VALID_WEBHOOK_URL_REGEX.test(value)) {
    return <Message id="validate.webhookURL.validUrl" />
  }
  return undefined
}

export function isValidUrl(urlString) {
  return !!VALID_URL_PATTERN.test(urlString)
}

export function validateAccountName(value) {
  return !!VALID_NAME.test(value)
}

export function validateName(name) {
  if (!name || name.trim() === '') {
    return 'Please enter a name'
  } else if (!VALID_NAME.test(name)) {
    return 'Please enter only letters or spaces.'
  }

  return null
}
